import { memo, type FC } from 'react';

import { TableHeadRowWrapper, TableHeadWrapper } from './styled.ts';
import type { TableHeadRowProps } from './types.ts';

export const TableHeadRow: FC<TableHeadRowProps> = memo(function TableHeadRow({ children, className }) {
  return (
    <TableHeadWrapper className={className}>
      <TableHeadRowWrapper>{children}</TableHeadRowWrapper>
    </TableHeadWrapper>
  );
});
